// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"f2b2344e","115":"676a7683","239":"9a76f879","312":"76cf6658","453":"36088cf4","455":"bab4ffca","457":"b3e7c259","596":"194a856d","851":"d3c7e600","977":"bfac33a6"}[chunkId] + ".chunk.js";
};